import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { find, groupBy } from 'lodash';
import { showSnackBar } from '../../store/AlertMessages/actionCreator';
import AlertMessages from '../Common/AlertMessages';
import AddDocButton from './addDocButton'
import { addQuestion } from '../../store/Assessments/actionCreator'
import { ERROR_ADD_QUESTION } from '../Common/Constants/errorMessages';
import { SUCCESS_ADD_QUESTION } from '../Common/Constants/successMessages';
import { getCourseOpenModeType } from '../../Helpers/basic';

const useStyles = makeStyles(theme => ({
  root: {
    border: '3px solid #f5f5f5',
    marginTop: 20
  },
  form: {
    '& .MuiTextField-root': {
      margin: 20,
    },
  },
  field: {
    width: '90%',
    '&.option': {
      width: '40%',
      margin: 0
    }
  },
  duplicate: {
    color: 'red',
    marginRight: 10,
    display: 'none',
    '&.show': {
      display: 'inline-block'
    }
  },
  addOptionButton: {
    textAlign: 'left',
    marginLeft: 50
  }

}));

function Objective(props) {
  const questionDetails = props.questionDetails
  const classes = useStyles();
  const [inProgress, setInProgress] = React.useState(false)
  const [options, setOptions] = React.useState(questionDetails.options || [])
  let formatedCorrectAnswer = questionDetails.correct_answer
  if (questionDetails.id) {
    if (typeof questionDetails.correct_answer === 'string' && questionDetails.correct_answer === '0') {
      formatedCorrectAnswer = Number(0)
    } else {
      formatedCorrectAnswer = Number(questionDetails.correct_answer)
    }
  } else {
    formatedCorrectAnswer = ''
  }
  const [correctOption, setCorrectOption] = React.useState(formatedCorrectAnswer);

  const [validationStatus, setValidationStatus] = React.useState({
    isValid: true,
    errorMessages: '',
    isDuplicateOption: false
  });
  const courseOpenedMode = getCourseOpenModeType();

  const addOption = () => {
    let allOptions = [...options]
    allOptions.push({ option: '' })
    setOptions(allOptions)
  }
  const triggerSetCorrectOption = event => {
    setCorrectOption(Number(event.target.value));
  }
  const successCallBack = res => {
    setInProgress(false)
    props.onQuestionAction()
    props.showSnackBar(
      {
        state: true,
        message: SUCCESS_ADD_QUESTION,
        type: 'success'
      }
    )
  }
  const failureCallBack = error => {
    setInProgress(false)
    props.onQuestionAction()
    props.showSnackBar(
      {
        state: true,
        message: ERROR_ADD_QUESTION,
        type: 'error'
      }
    )
  }
  const formatOptions = () => {
    let enteredOptions = []
    for (let i in options) {
      const option = document.getElementById('option_' + i).value
      enteredOptions.push({ id: i, option: option })
    }
    setOptions(enteredOptions)
    return enteredOptions
  }
  const removePrevDuplicates = () => {
    const duplicates = document.getElementsByClassName("show");
    if (duplicates.length) {
      for (let i in duplicates) {
        if (duplicates[i] && duplicates[i].classList) {
          duplicates[i].classList.remove('show')
        }
      }
    }
  }
  const triggerAddQuestion = evnt => {
    evnt.preventDefault()
    setValidationStatus({
      isValid: true,
      errorMessages: '',
    })
    removePrevDuplicates()
    const question = document.getElementById('question').value
    const enteredOptions = formatOptions()
    const emptyOption = find(enteredOptions, { option: '' })
    const groupedBy = groupBy(enteredOptions, 'option')
    let isDuplicateOption = false
    for (let i in groupedBy) {
      if (groupedBy[i].length > 1) {
        isDuplicateOption = true
        const lastElem = groupedBy[i].length - 1
        const element = document.getElementById('duplicate_' + groupedBy[i][lastElem].id)
        element.classList.add('show');
      }
    }
    if (emptyOption || question === '') {
      setValidationStatus({
        isValid: false,
        errorMessages: 'Please fill all required fields!',
      })
      return
    }
    if (options.length < 2) {
      setValidationStatus({
        isValid: false,
        errorMessages: 'Please add minimum 2 options!',
      })
      return
    }
    if (isDuplicateOption) {
      setValidationStatus({
        isValid: false,
        errorMessages: 'Please avoid duplicate entries!',
      })
      return
    }
    if (typeof correctOption !== 'number' || correctOption === '') {
      setValidationStatus({
        isValid: false,
        errorMessages: 'Please select correct option!',
      })
      return
    }
    setInProgress(true)
    if (props.lessonId) {
      let payload = {
        lesson_id: Number(props.lessonId),
        assessment_id: props.assessmentId,
        type: 'objective',
        scenario: document.getElementById('scenario').value,
        question: document.getElementById('question').value,
        correctAnswer: correctOption,
        options: enteredOptions
      }
      if (questionDetails.id) {
        payload.id = questionDetails.id
      }
      addQuestion(payload, successCallBack, failureCallBack)
    }
    else if (props.moduleId) {
      let payload = {
        module_id: Number(props.moduleId),
        assessment_id: props.assessmentId,
        type: 'objective',
        scenario: document.getElementById('scenario').value,
        question: document.getElementById('question').value,
        correctAnswer: correctOption,
        options: enteredOptions
      }
      if (questionDetails.id) {
        payload.id = questionDetails.id
      }
      addQuestion(payload, successCallBack, failureCallBack)
    }
    else if (props.courseId) {
      let payload = {
        course_id: Number(props.courseId),
        assessment_id: props.assessmentId,
        type: 'objective',
        scenario: document.getElementById('scenario').value,
        question: document.getElementById('question').value,
        correctAnswer: correctOption,
        options: enteredOptions
      }
      if (questionDetails.id) {
        payload.id = questionDetails.id
      }
      addQuestion(payload, successCallBack, failureCallBack)
    } else if (props && props.from === 'externalType') {
      let payload = {
        assessment_id: props.assessmentId,
        type: 'objective',
        scenario: document.getElementById('scenario').value,
        question: document.getElementById('question').value,
        correctAnswer: correctOption,
        options: enteredOptions
      }
      if (questionDetails.id) {
        payload.id = questionDetails.id
      }
      addQuestion(payload, successCallBack, failureCallBack)
    }
  }
  return (
    <Paper elevation={0} className={classes.root}>
      <form className={classes.form} noValidate autoComplete="off" onSubmit={triggerAddQuestion}>
        {!validationStatus.isValid ? (
          <div style={{ marginTop: '20px', width: '42%', marginBottom: '18px', display: 'inline-block' }}>
            <AlertMessages status="error" message={validationStatus.errorMessages} />
          </div>
        ) : null}
        <TextField
          id="scenario"
          label="Scenario"
          aria-label="Add Question scenario"
          defaultValue={questionDetails.scenario || ''}
          multiline
          rows="4"
          variant="outlined"
          className={classes.field}
          inputProps={{ maxLength: 1000 }}
          InputLabelProps={{
            shrink: true,
          }}
          helperText="max: 1000 chars"
          autoFocus={true}
        />
        <TextField
          id="question"
          defaultValue={questionDetails.question || ''}
          required={true}
          label="Question"
          variant="outlined"
          className={classes.field}
          inputProps={{ maxLength: 500 }}
          InputLabelProps={{
            shrink: true,
          }}
          helperText="max: 500 chars"
        />
        {options.length ? (
          <div>
            <RadioGroup aria-label="Correct answer" name="correctOption" value={typeof correctOption === 'string' && questionDetails.id ? 0 : correctOption} onChange={triggerSetCorrectOption} row>
              {options.map((row, key) => (
                <div key={key} style={{ width: '100%', marginBottom: 30 }}>
                  <span id={`duplicate_${key}`} className={classes.duplicate} aria-label="duplicate entry">duplicate</span>
                  <TextField
                    required
                    autoFocus={true}
                    id={`option_${key}`}
                    label={`Option ${key + 1}`}
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue={row.option}
                    placeholder={`Enter option ${key + 1}`}
                    inputProps={{ maxLength: 250, required: true }}
                    helperText="Max 250 Characters"
                    className={classes.field + ' option'}
                  />
                  <FormControlLabel
                    value={Number(key)}
                    control={<Radio color="primary" />}
                    label="set this as a Correct Answer"
                    labelPlacement="end"
                    style={{ marginLeft: 20 }}
                  />
                </div>
              ))}
            </RadioGroup>
          </div>
        ) : null}
        <div style={{ width: '40%', marginLeft: 33 }}>
          {courseOpenedMode !== 'visit_mode' ? (
            <React.Fragment>
              <AddDocButton onClick={addOption} />
              <Link
                component="button"
                variant="body2"
                onClick={addOption}
              >Add Option
              </Link>
            </React.Fragment>
          ) : null}
        </div>
        <div>
          {courseOpenedMode !== 'visit_mode' ? (
            <React.Fragment>
              <Button variant="contained" color="primary" onClick={triggerAddQuestion} disabled={inProgress}>
                {inProgress ? (
                  <CircularProgress size={30} style={{ marginRight: 10 }} />
                ) : null}
                {questionDetails.id ? 'Update question' : 'Add question'}
              </Button>
            </React.Fragment>
          ) : null}
        </div>
      </form>
    </Paper>
  )

}

const mapStateToProps = state => {
  return {}
}

export default connect(
  mapStateToProps, { showSnackBar }
)(Objective);
